/*
Copyright 2022 Fondazione Bruno Kessler
Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
except in compliance with the Licence.

You may obtain a copy of the Licence at:
http://ec.europa.eu/idabc/eupl.html

Unless required by applicable law or agreed to in writing, software distributed under
the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
ANY KIND, either express or implied. See the Licence for the specific language
governing permissions and limitations under the Licence.
*/
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabService {

  private activeTabId$ = new BehaviorSubject<string>('patient-profile');

  setActiveTabId(id: string) {
    console.log("setActiveTabId in tabservice:", id);
    localStorage.setItem('tabSelezionato', id);
    this.activeTabId$.next(id);
  }

  getActiveTabId() {
    console.log('getActiveTabId', this.activeTabId$.asObservable());
    if (localStorage.getItem('tabSelezionato') !== null && localStorage.getItem('tabSelezionato') !== 'patient-profile') {
      this.activeTabId$.next(localStorage.getItem('tabSelezionato')!);
    }
    return this.activeTabId$.asObservable();
  }

  getActiveTabIdValue(): string {
    return this.activeTabId$.getValue();
  }
}
